module.exports = __webpack_public_path__ + "static/media/deadly.9677b84b.svg";